import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import services from 'services';

const Edit = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedRowId = useSelector(selectors.configurator.getNOPOSelectedRowId);
  const selectedRow = useSelector(selectors.configurator.getNOPOSelectedRow);
  const editRowId = useSelector(selectors.configurator.getNOPOEditedRowId);

  const editRow = async () => {
    try {
      if (selectedRow == null) throw new Error('No row selected');
      const { data: casuals } = await services.getWfCasuals(selectedRow.idCompany);
      const { data: definitions } = await services.getWfDefinitions(selectedRow.idCompany);
      dispatch(actions.configurator.setWfCasuals(casuals));
      dispatch(actions.configurator.setWfDefinitions(definitions));
      dispatch(actions.configurator.setNoPoEditedRowId(selectedRowId));
      dispatch(actions.configurator.setNopoNotModifiedRow(selectedRow));
      dispatch(actions.app.setDisabledDropdown(true));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <CommonButton
      id="edit-row-action-table"
      action={async () => await editRow()}
      scope="tertiary"
      value={t('nopoEditActionTable')}
      customIcon="pen"
      disabled={
        !selectedRowId ||
        editRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.ACTION_TABLE_EDIT_ROW, selectedRow?.companyName)
      }
    />
  );
};

export default Edit;
